<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" [routerLink]="'/settings'" />
    </ion-buttons>
    <ion-title>{{ 'SETTINGS.LANGUAGE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-radio-group (ionChange)="setLanguage($event)" [value]="currentLanguage()">
      <ion-item>
        <ion-radio [translate]="'SETTINGS.EN'" justify="start" label-placement="end" value="en" />
      </ion-item>
      <ion-item>
        <ion-radio [translate]="'SETTINGS.DA'" justify="start" label-placement="end" value="da" />
      </ion-item>
      @if (targetGroup() !== 'gestational') {
        <ion-item>
          <ion-radio [translate]="'SETTINGS.AU'" justify="start" label-placement="end" value="au" />
        </ion-item>
        <ion-item>
          <ion-radio [translate]="'SETTINGS.SV'" justify="start" label-placement="end" value="sv" />
        </ion-item>
      }
    </ion-radio-group>
  </ion-list>
</ion-content>
